var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleErrorDialog, showProgressDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export function showCheckInProgressDialog({ t, fileId, file, storage, onSuccess, comment }) {
    showProgressDialog({
        title: t('multipleFilesUpload.uploadFilesProgress'),
        callback: (done) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield storage.checkIn({
                    fileId: fileId,
                    comment: comment,
                    content: file,
                    contentType: file.type,
                    contentLength: file.size,
                });
                showAlertSnackbar({
                    horizontalPosition: 'center',
                    type: 'success',
                    verticalPosition: 'bottom',
                    autoHideDuration: 2000,
                    message: t('checkInDialog.checkedInSnackbar'),
                });
                done();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            }
            catch (error) {
                done();
                handleErrorDialog(error);
            }
        }),
    });
}
